/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { bindActionCreators } from "redux";
import { Button } from "antd";
import { includes } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { changeQuantity, removeAllChangedProductFromOrderReducer } from "reducers/orders";
import { ButtonSpinner } from "components/Spinner";
import OrderQtyModal from "components/orders/OrderQtyModal";
import Constants from "utilities/appConstants";
import { checkEligibleForFoc, errorToast } from "utilities/utils";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import { changeFocStatus } from "reducers/common";
/* Project Import will be here */

class QuantityCounter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenOrderQtyModal: false
    };
  }

  increment = (e) => {
    e.stopPropagation();

    if (this.checkForFocValidation()) {
      let currentPieceCount = this.props.orders.data[this.props.product.ProductId].count;
      let totalQty = currentPieceCount + (this.props.orders.data[this.props.product.ProductId].case_count * this.props.product.ConversionQty);
      let count = currentPieceCount;

      /* Check for isEnableMinOrderQty logic */
      if (this.props.appSettings.isEnableMinOrderQty && this.props.product.MinORDQty !== 0) {
        /* If the added count of the product is === 0 then directly add the MinOrderQty value */
        if (totalQty === 0)
          count = currentPieceCount + this.props.product.MinORDQty;

        /* Else if check for it should not exceed the MaxOrderQty value */
        else if ((totalQty + 1) > this.props.product.MaxORDQty && this.props.product.MaxORDQty !== 0)
          errorToast({ content: this.props.translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });

        /* Else check for RoundOrderQty and assign the value to the product */
        else {
          if (this.props.product.MaxORDQty === 0 || ((totalQty + this.props.product.RoundORDQty) <= this.props.product.MaxORDQty))
            count = currentPieceCount + this.props.product.RoundORDQty;
          else {
            errorToast({ content: this.props.translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
          }

        }
      }
      /* If isEnableMinOrderQty is set to false do not check any conditions directly increment the count to +1 */
      else
        count = currentPieceCount + 1;

      /* Save updated count */
      this.changeUpdatedQty(count, false);
    }
  };

  decrement = (e) => {
    e.stopPropagation();

    if (this.checkForFocValidation()) {
      let count = 0;
      let currentPieceCount = this.props.orders.data[this.props.product.ProductId].count;
      let currentCaseCount = this.props.orders.data[this.props.product.ProductId].case_count * this.props.product.ConversionQty;
      let totalQty = currentPieceCount - currentCaseCount;

      /* Check for isEnableMinOrderQty logic */
      if (this.props.appSettings.isEnableMinOrderQty && this.props.product.MinORDQty !== 0) {
        if (totalQty === this.props.product.MinORDQty)
          count = 0;
        else
          count = currentPieceCount - this.props.product.RoundORDQty
      }
      else
        count = currentPieceCount - 1;

      /* Save updated count */
      this.changeUpdatedQty(count, (count === 0 && currentCaseCount < this.props.product.MinORDQty) ? true : false);
    }
  };

  /* Save updated count */
  changeUpdatedQty = (updatedCount, isClearCaseCount) => {
    if (updatedCount >= 0 && updatedCount <= 9999) {
      const requestObject = {
        count: updatedCount,
        id: this.props.product.ProductId,
        isChanged: true
      };
      if (isClearCaseCount)
        requestObject.case_count = 0;

      /* Check for qty 0 and from cart */
      if (this.checkForZeroQtyAndCartPage(updatedCount)) {
        this.props.zeroCallback(this.props.product.ProductId);
      }
      else {
        this.props.actions.changeQuantity(requestObject);
      }
    }
  }

  /* Check for qty 0 and from cart */
  checkForZeroQtyAndCartPage = (pieceQty) => {
    const currentCaseCount = this.props.orders.data[this.props.product.ProductId].case_count * this.props.product.ConversionQty;
    const productInCart = includes(this.props.cart.ids, this.props.product.ProductId);
    if (this.props.zeroCallback && productInCart && pieceQty === 0 && currentCaseCount === 0)
      return true;
    else
      return false;
  }

  checkForFocValidation = () => {
    if (this.props.appSettings.isEnableFoc) {
      if (checkEligibleForFoc(this.props.orders, !this.props.product.IsSaleable)) {
        return true;
      }
      else {
        /* Check for if any products added in the cart */
        if (this.props.cart.ids.length <= 0) {
          /* Ask for clear the added products in the local */
          modalConfirmationHook(this.props.translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
            this.props.translate,
            (() => {
              this.props.actions.removeAllChangedProductFromOrderReducer();
              this.props.actions.changeFocStatus(false);
            }));
        }
        else {
          errorToast({
            content: this.props.translate("products.foc.focRequestValidation")
          });
        }

        return false;
      }
    }
    else {
      return true;
    }
  }

  onQtyChanged = (value) => {
    if (value >= 0 && value <= 9999 && this.checkForFocValidation()) {
      const requestObject = {
        count: Number(value),
        id: this.props.product.ProductId,
        isChanged: true
      };

      var totalQty = Number(value) + (this.props.orders.data[this.props.product.ProductId].case_count * this.props.product.ConversionQty);
      if (totalQty < this.props.product.MinORDQty) {
        requestObject.case_count = 0;
      }

      /* Check for qty 0 and from cart */
      if (this.checkForZeroQtyAndCartPage(Number(value))) {
        this.props.zeroCallback(this.props.product.ProductId);
      }
      else {
        this.props.actions.changeQuantity(requestObject);
      }
    }
  };

  handlePieceInput = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^\d$/.test(keyValue))
      event.preventDefault();
  }

  openOrderQtyModal = () => {
    this.setState({ isOpenOrderQtyModal: true });
  }

  closeOrderQtyModal = () => {
    this.setState({ isOpenOrderQtyModal: false });
  }

  render() {
    const { orders, product, appSettings } = this.props;
    const disableButtons = ((appSettings.isRestrictSIHProducts && product.SIH === 0) || this.props.isDisable);

    return (
      <React.Fragment>
        {(!orders.isLoading && (product.IsFree ? true : orders.data[product.ProductId])) ? (
          <div className="d-flex align-items-center">
            {product.IsFree ? (
              <div className="product-quantity d-flex align-items-center">
                <div className="card-quantity-input">
                  <p className="m-auto">{product.pieceQTY}</p>
                </div>
              </div>
            ) : (
              <div className="product-quantity d-flex align-items-center">
                <Button className={disableButtons ? "product-qul-disabled" : "product-qul"}
                  icon={<i className="icon-minus" />}
                  size="small"
                  onClick={this.decrement}
                  disabled={disableButtons}
                />

                <div className="card-quantity-input">
                  <Button
                    type="text"
                    size="small"
                    onClick={this.openOrderQtyModal}
                    disabled={disableButtons}
                  >
                    {orders.data[product.ProductId].count}
                  </Button>
                </div>

                <Button className={disableButtons ? "product-qul-disabled" : "product-qul"}
                  icon={<span className="card-plus-sign">+</span>}
                  size="small"
                  onClick={this.increment}
                  disabled={disableButtons}
                />
              </div>
            )}
          </div>)
          :
          <div className="loding-spinner-div">{orders.isLoading && <ButtonSpinner />}</div>
        }

        {this.state.isOpenOrderQtyModal &&
          <OrderQtyModal
            closeOrderQtyModal={this.closeOrderQtyModal}
            onQtyChanged={this.onQtyChanged}
            isShowOrderQtyModal={this.state.isOpenOrderQtyModal}
            orders={orders}
            product={product}
            appSettings={appSettings}
            pageType={Constants.PIECE_QTY}
          />
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    cart: state.cart,
    appSettings: state.appSettings,
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      changeQuantity,
      removeAllChangedProductFromOrderReducer,
      changeFocStatus
    }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuantityCounter);